<ul>
  <li *ngFor="let url of currentBreadcrumb">
    <i class="fas fa-angle-right"></i>
    <a [routerLink]="goTo(url.toLowerCase())">{{url}}</a>
  </li>
</ul>